module.exports = __webpack_public_path__ + "static/media/start-blood-and-imaging-badge.fcdd74cd.svg";